(function () {
  var NAMES = { jogar: 'Jogar', aprender: 'Aprender', criar: 'Criar', descobrir: 'Descobrir' };
  var LINES = {
    jogar: 'JOGAR CONECTADO! 🎮',
    aprender: 'DESCOBERTA CONECTADA! 📚',
    criar: 'CRIATIVIDADE CONECTADA! 🎨',
    descobrir: 'AVENTURA CONECTADA! 🚀'
  };
  var ORDER = ['jogar', 'aprender', 'criar', 'descobrir'];
  var QUESTIONS = [
    {
      q: 'Qual é a brincadeira de hoje?',
      options: [
        { t: 'Jogar no videogame', k: 'gamer' },
        { t: 'Estudar, desenhar e assistir', k: 'cat6cobre' },
        { t: 'Ficar na mesa, pertinho', k: 'cat5e100' },
        { t: 'Brincar leve, sem pressa', k: 'cat5ecca' }
      ]
    },
    {
      q: 'Onde vai ser a brincadeira?',
      options: [
        { t: 'Na frente do videogame', k: 'gamer' },
        { t: 'No quarto, o dia inteiro', k: 'cat6cobre' },
        { t: 'Em mais de um cômodo', k: 'cat6cca' },
        { t: 'Na mesma mesa, do meu lado', k: 'cat5ecca' }
      ]
    },
    {
      q: 'O que não pode faltar nesse dia?',
      options: [
        { t: 'A partida, sem travar', k: 'gamer' },
        { t: 'Uma conexão firme', k: 'cat6cobre' },
        { t: 'Internet boa pela casa', k: 'cat6cca' },
        { t: 'Um cabo simples para hoje', k: 'cat5e100' }
      ]
    }
  ];
  var CABLES = {
    gamer: {
      name: 'Linha Gamer',
      text: 'Para o videogame de hoje, o cabo ideal é da Linha Gamer. A partida fica firme.',
      href: '/collections/linha-gamer'
    },
    cat6cobre: {
      name: 'CAT6 100% cobre',
      text: 'Para estudar, desenhar e assistir, o cabo ideal é um CAT6 100% cobre.',
      href: '/collections/cat-6'
    },
    cat6cca: {
      name: 'CAT6 CCA',
      text: 'Para a internet pela casa, o cabo ideal é um CAT6 CCA.',
      href: '/collections/cat6-cca'
    },
    cat5e100: {
      name: 'CAT5e 100% cobre',
      text: 'Para a brincadeira na mesa, o cabo ideal é um CAT5e 100% cobre.',
      href: '/collections/cat5e-100-cobre'
    },
    cat5ecca: {
      name: 'CAT5e CCA',
      text: 'Para brincar leve hoje, o cabo ideal é um CAT5e CCA.',
      href: '/collections/cat5e-cca'
    }
  };

  function boot(section) {
    if (!section || section.getAttribute('data-dcg-ready') === 'true') return;
    section.setAttribute('data-dcg-ready', 'true');

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var openBtn = section.querySelector('[data-dcg-open]');
    var modal = section.querySelector('[data-dcg-modal]');
    var dialog = section.querySelector('[data-dcg-dialog]');
    var app = section.querySelector('[data-dcg-app]');
    var dots = section.querySelector('[data-dcg-dots]');
    var soundBtn = section.querySelector('[data-dcg-sound]');
    var closeBtn = section.querySelector('[data-dcg-close]');
    if (!openBtn || !modal || !app) return;

    var links = [];
    var tip = { x: 0, y: 0 };
    var goal = { x: 0, y: 0 };
    var slack = null;
    var busy = false;
    var armed = false;
    var dragging = false;
    var moved = false;
    var suppressClick = false;
    var ignorePortClick = false;
    var playing = false;
    var waits = [];
    var soundOn = false;
    var audio = null;
    var board = null;
    var cables = null;
    var svg = null;
    var plug = null;
    var anchor = null;
    var origin = null;
    var phone = false;
    var wireMode = false;
    var lastCable = 'cat5e100';
    var quizStep = 0;
    var firstPick = 'cat5e100';
    var everydayPick = '';
    var scores = { gamer: 0, cat6cobre: 0, cat6cca: 0, cat5e100: 0, cat5ecca: 0 };

    function later(fn, ms) {
      waits.push(window.setTimeout(fn, reduce ? 0 : ms));
    }

    function clearWaits() {
      waits.forEach(clearTimeout);
      waits = [];
    }

    function narrow() {
      return window.matchMedia('(max-width: 700px)').matches;
    }

    function say(text) {
      var node = app.querySelector('[data-dcg-status]');
      if (node) node.textContent = text || '';
    }

    function paintDots() {
      if (!dots) return;
      dots.hidden = true;
    }

    function open() {
      modal.hidden = false;
      document.documentElement.classList.add('dcg-lock');
      intro();
    }

    function close() {
      dragging = false;
      busy = false;
      playing = false;
      wireMode = false;
      clearWaits();
      modal.hidden = true;
      document.documentElement.classList.remove('dcg-lock');
      openBtn.focus();
    }

    function intro() {
      clearWaits();
      playing = false;
      links = [];
      busy = false;
      armed = false;
      paintDots();
      section.setAttribute('data-phase', 'intro');
      app.innerHTML =
        '<div class="dcg-open">' +
          parkScene() +
          '<p class="dcg-kicker" data-dcg-kicker></p>' +
          '<h2 data-dcg-heading></h2>' +
          '<p data-dcg-lead></p>' +
          '<div class="dcg-actions">' +
            '<button type="button" class="dcg-btn" data-dcg-start></button>' +
            '<button type="button" class="dcg-btn dcg-btn--ghost" data-dcg-secret>LIGAR A PIPA</button>' +
          '</div>' +
        '</div>';
      app.querySelector('[data-dcg-kicker]').textContent = section.getAttribute('data-kicker') || 'Dia das Crianças';
      app.querySelector('[data-dcg-heading]').textContent = section.getAttribute('data-title') || 'HOJE O FIO TAMBÉM BRINCA';
      app.querySelector('[data-dcg-lead]').textContent = section.getAttribute('data-lead') || 'Escolha a brincadeira de hoje e veja o cabo. Ou ligue os fios.';
      var start = app.querySelector('[data-dcg-start]');
      start.textContent = section.getAttribute('data-start') || 'COMEÇAR';
      if (start) start.focus();
    }

    function begin() {
      clearWaits();
      wireMode = false;
      playing = false;
      busy = false;
      quizStep = 0;
      firstPick = 'cat5e100';
      everydayPick = '';
      scores = { gamer: 0, cat6cobre: 0, cat6cca: 0, cat5e100: 0, cat5ecca: 0 };
      showQuestion();
    }

    function showQuestion() {
      var item = QUESTIONS[quizStep];
      section.setAttribute('data-phase', 'quiz');
      app.innerHTML = '<div class="dcg-quiz">' + parkScene() + '<p class="dcg-kicker">Dia das Crianças</p><p class="dcg-step" data-dcg-step></p><h2></h2><div class="dcg-choices"></div></div>';
      app.querySelector('[data-dcg-step]').textContent = (quizStep + 1) + ' / ' + QUESTIONS.length;
      app.querySelector('h2').textContent = item.q;
      var box = app.querySelector('.dcg-choices');
      item.options.forEach(function (option) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'dcg-choice';
        button.setAttribute('data-dcg-choice', '');
        button.setAttribute('data-key', option.k);
        button.textContent = option.t;
        box.appendChild(button);
      });
      box.querySelector('button').focus();
    }

    function pick(button) {
      if (busy) return;
      var key = button.getAttribute('data-key');
      if (!scores[key] && scores[key] !== 0) return;
      if (quizStep === 0) firstPick = key;
      if (key !== 'gamer' && !everydayPick) everydayPick = key;
      scores[key] += 1;
      button.classList.add('is-on');
      busy = true;
      later(function () {
        busy = false;
        if (quizStep < QUESTIONS.length - 1) {
          quizStep += 1;
          showQuestion();
        } else {
          showResult(bestCable());
        }
      }, 220);
    }

    function bestCable() {
      if ((scores.gamer || 0) >= 2) return 'gamer';
      var best = everydayPick || 'cat5e100';
      var max = scores[best] || 0;
      ['cat5e100', 'cat5ecca', 'cat6cobre', 'cat6cca'].forEach(function (key) {
        if ((scores[key] || 0) > max) {
          max = scores[key];
          best = key;
        }
      });
      return best;
    }

    function showResult(key) {
      clearWaits();
      wireMode = false;
      playing = false;
      busy = false;
      lastCable = CABLES[key] ? key : 'cat5e100';
      var cable = CABLES[lastCable];
      section.setAttribute('data-phase', 'result');
      app.innerHTML =
        '<div class="dcg-quiz">' +
          parkScene(false) +
          '<p class="dcg-kicker">Dia das Crianças</p>' +
          '<h2 data-dcg-cable></h2>' +
          '<p class="dcg-lead" data-dcg-cable-text></p>' +
          '<p class="dcg-wish">Feliz Dia das Crianças!</p>' +
          '<div class="dcg-actions">' +
            '<a class="dcg-btn" data-dcg-cable-link>VER ESSE CABO</a>' +
          '</div>' +
          '<button type="button" class="dcg-textbtn" data-dcg-again>De novo</button>' +
        '</div>';
      app.querySelector('[data-dcg-cable]').textContent = cable.name;
      app.querySelector('[data-dcg-cable-text]').textContent = cable.text;
      var link = app.querySelector('[data-dcg-cable-link]');
      link.href = cable.href;
      link.focus();
    }

    function renderWorld() {
      slack = null;
      phone = narrow();
      var spots = layout();
      app.innerHTML =
        '<div class="dcg-map" data-dcg-board>' +
          '<div class="dcg-sky" aria-hidden="true">' + scenery() + skyBits() + '</div>' +
          spots.map(worldHtml).join('') +
          spoolHtml(spots) +
          '<svg class="dcg-cables" data-dcg-svg><g data-dcg-cables></g></svg>' +
          '<button type="button" class="dcg-plug" data-dcg-plug aria-pressed="false" aria-label="Conector RJ45. Arraste até uma área ou toque para selecionar.">' + plugSvg() + '</button>' +
          '<p class="dcg-status" data-dcg-status role="status"></p>' +
        '</div>';
      board = app.querySelector('[data-dcg-board]');
      svg = app.querySelector('[data-dcg-svg]');
      cables = app.querySelector('[data-dcg-cables]');
      plug = app.querySelector('[data-dcg-plug]');
      anchor = app.querySelector('[data-anchor]');
      links.forEach(function (id) {
        var world = board.querySelector('[data-port="' + id + '"]');
        if (world) world.classList.add('is-live');
      });
      void board.offsetWidth;
      tip = homePoint();
      goal = { x: tip.x, y: tip.y };
      paintDots();
      draw();
    }

    function layout() {
      if (phone) {
        return [
          { id: 'jogar', x: 28, y: 22 },
          { id: 'aprender', x: 72, y: 22 },
          { id: 'criar', x: 28, y: 50 },
          { id: 'descobrir', x: 72, y: 50 },
          { id: 'spool', x: 50, y: 76, spool: true }
        ];
      }
      return [
        { id: 'jogar', x: 18, y: 24 },
        { id: 'aprender', x: 82, y: 22 },
        { id: 'criar', x: 20, y: 74 },
        { id: 'descobrir', x: 80, y: 72 },
        { id: 'spool', x: 50, y: 48, spool: true }
      ];
    }

    function worldHtml(item) {
      if (item.spool) return '';
      return '<button type="button" class="dcg-world dcg-world--' + item.id + '" data-port="' + item.id + '" data-id="' + item.id + '" style="left:' + item.x + '%;top:' + item.y + '%" aria-label="' + NAMES[item.id] + '">' +
        scene(item.id) +
        '<span class="dcg-port" data-slot></span>' +
        '<span class="dcg-world__name">' + NAMES[item.id] + '</span>' +
        '<span class="dcg-ask" aria-hidden="true">?</span>' +
      '</button>';
    }

    function spoolHtml(spots) {
      var spool = spots.filter(function (item) { return item.spool; })[0];
      return '<div class="dcg-spool" style="left:' + spool.x + '%;top:' + spool.y + '%" aria-hidden="true">' +
        '<svg viewBox="0 0 80 64"><ellipse cx="40" cy="40" rx="28" ry="12" fill="#16203a"/>' +
        '<path d="M16 40c0-8 11-14 24-14s24 6 24 14-11 12-24 12S16 48 16 40z" fill="none" stroke="#b88912" stroke-width="6"/>' +
        '<path d="M20 40c0-5 9-9 20-9s20 4 20 9-9 8-20 8-20-3-20-8z" fill="none" stroke="#f0c014" stroke-width="4"/>' +
        '</svg><span class="dcg-port" data-anchor></span></div>';
    }

    function pointOf(el) {
      var b = board.getBoundingClientRect();
      var r = el.getBoundingClientRect();
      return { x: r.left + r.width / 2 - b.left, y: r.top + r.height / 2 - b.top };
    }

    function anchorPoint() {
      if (wireMode && board) return rowAnchor(Math.min(links.length, 2));
      return anchor ? pointOf(anchor) : { x: 80, y: 80 };
    }

    function homePoint() {
      if (wireMode && board) {
        var start = rowAnchor(Math.min(links.length, 2));
        return { x: start.x + board.clientWidth * 0.28, y: start.y };
      }
      var a = anchorPoint();
      return { x: a.x + (phone ? 42 : 8), y: a.y + (phone ? 54 : 78) };
    }

    function slotPoint(id) {
      var port = board.querySelector('[data-port="' + id + '"]');
      if (!port) return anchorPoint();
      var slot = port.querySelector('[data-slot]') || port;
      return pointOf(slot);
    }

    function rowAnchor(index) {
      if (wireMode) {
        var start = board.querySelector('[data-anchor]');
        if (start) return pointOf(start);
        return { x: 80, y: 120 };
      }
      var port = board.querySelector('[data-port="' + index + '"]');
      return { x: 28, y: port ? pointOf(port).y : 80 };
    }

    function startWire() {
      clearWaits();
      wireMode = true;
      playing = true;
      links = [];
      busy = false;
      armed = false;
      slack = null;
      phone = narrow();
      section.setAttribute('data-phase', 'wire');
      app.innerHTML =
        '<div class="dcg-map dcg-wire" data-dcg-board>' +
          parkScene() +
          '<p class="dcg-wire__note">Leve o fio da pipa até o carretel</p>' +
          '<div class="dcg-reel-kite" aria-hidden="true">' + kiteOnly() + '<span data-anchor></span></div>' +
          '<svg class="dcg-cables" data-dcg-svg><g data-dcg-cables></g></svg>' +
          '<button type="button" class="dcg-reel" data-port="0" style="left:74%;top:52%" aria-label="Carretel">' + spoolSvg() + '<span data-slot></span></button>' +
          '<button type="button" class="dcg-plug dcg-knot" data-dcg-plug aria-pressed="false" aria-label="Ponta do fio. Arraste até o carretel ou toque para selecionar."></button>' +
        '</div>';
      board = app.querySelector('[data-dcg-board]');
      svg = app.querySelector('[data-dcg-svg]');
      cables = app.querySelector('[data-dcg-cables]');
      plug = app.querySelector('[data-dcg-plug]');
      anchor = null;
      void board.offsetWidth;
      tip = homePoint();
      goal = { x: tip.x, y: tip.y };
      draw();
    }

    function wireDone() {
      if (modal.hidden) return;
      signal('0');
      later(showDiscount, 400);
    }

    function showDiscount() {
      if (modal.hidden) return;
      if (window.ddcUnlock) window.ddcUnlock();
      clearWaits();
      wireMode = false;
      playing = false;
      busy = false;
      section.setAttribute('data-phase', 'discount');
      app.innerHTML =
        '<div class="dcg-quiz">' +
          parkScene() +
          '<p class="dcg-kicker">Dia das Crianças</p>' +
          '<h2>Pipa no carretel!</h2>' +
          '<p class="dcg-lead">Você ligou o fio e ganhou 8% OFF nos patch cords.</p>' +
          '<p class="dcg-copied" data-dcg-copied aria-live="polite"></p>' +
          '<p class="dcg-code">CRIANCAS</p>' +
          '<div class="dcg-actions">' +
            '<button type="button" class="dcg-btn" data-dcg-copy>COPIAR CUPOM</button>' +
            '<a class="dcg-btn dcg-btn--ghost" data-dcg-shop>USAR O DESCONTO</a>' +
          '</div>' +
          '<p class="dcg-wish">Feliz Dia das Crianças!</p>' +
        '</div>';
      var shop = app.querySelector('[data-dcg-shop]');
      shop.href = section.getAttribute('data-link') || '/collections/patch-cord';
      app.querySelector('[data-dcg-copy]').focus();
    }

    function curve(a, b, live) {
      var dx = b.x - a.x;
      var dy = b.y - a.y;
      var len = Math.hypot(dx, dy) || 1;
      var sag = wireMode ? Math.min(18, 4 + len * 0.03) : Math.min(150, 28 + len * 0.32);
      var c1x = a.x + dx * 0.25;
      var c1y = a.y + Math.min(100, sag);
      var tx = a.x + dx * 0.62;
      var ty = (a.y + b.y) / 2 + sag * 0.35;
      if (live) {
        if (!slack) slack = { x: tx, y: ty };
        var glide = reduce ? 1 : 0.22;
        slack.x += (tx - slack.x) * glide;
        slack.y += (ty - slack.y) * glide;
        tx = slack.x;
        ty = slack.y;
      }
      return {
        d: 'M ' + a.x.toFixed(1) + ' ' + a.y.toFixed(1) + ' C ' + c1x.toFixed(1) + ' ' + c1y.toFixed(1) + ' ' + tx.toFixed(1) + ' ' + ty.toFixed(1) + ' ' + b.x.toFixed(1) + ' ' + b.y.toFixed(1),
        angle: Math.atan2(b.y - ty, b.x - tx) * 180 / Math.PI
      };
    }

    function layers(d) {
      return '<path class="dcg-cable is-shadow" d="' + d + '"></path><path class="dcg-cable is-edge" d="' + d + '"></path><path class="dcg-cable" d="' + d + '"></path><path class="dcg-cable is-sheen" d="' + d + '"></path>';
    }

    function draw() {
      if (wireMode) {
        drawWires();
        return;
      }
      if (!board || !svg || !cables || !plug) return;
      var w = board.clientWidth;
      var h = board.clientHeight;
      if (!w || !h) return;
      svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
      var a = anchorPoint();
      var html = '';
      var locked = board.querySelectorAll('.dcg-plug.is-locked');
      if (locked.length !== links.length) {
        board.querySelectorAll('.dcg-plug.is-locked').forEach(function (node) { node.remove(); });
        links.forEach(function () {
          var node = document.createElement('span');
          node.className = 'dcg-plug is-locked';
          node.innerHTML = plugSvg();
          node.setAttribute('aria-hidden', 'true');
          board.appendChild(node);
        });
        locked = board.querySelectorAll('.dcg-plug.is-locked');
      }
      links.forEach(function (id, index) {
        var line = curve(a, slotPoint(id), false);
        html += layers(line.d);
        place(locked[index], slotPoint(id), line.angle);
      });
      if (!plug.hidden) {
        var live = curve(a, tip, true);
        html += layers(live.d);
        place(plug, tip, live.angle);
      }
      cables.innerHTML = html;
      markNear();
    }

    function drawWires() {
      if (!board || !svg || !cables || !plug) return;
      var w = board.clientWidth;
      var h = board.clientHeight;
      if (!w || !h) return;
      svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
      var html = '';
      var locked = board.querySelectorAll('.dcg-knot.is-locked');
      if (locked.length !== links.length) {
        board.querySelectorAll('.dcg-knot.is-locked').forEach(function (node) { node.remove(); });
        links.forEach(function () {
          var node = document.createElement('span');
          node.className = 'dcg-knot is-locked';
          node.setAttribute('aria-hidden', 'true');
          board.appendChild(node);
        });
        locked = board.querySelectorAll('.dcg-knot.is-locked');
      }
      links.forEach(function (id, index) {
        var line = curve(rowAnchor(index), slotPoint(id), false);
        html += stringLayer(line.d);
        place(locked[index], slotPoint(id), line.angle);
      });
      if (!plug.hidden && links.length < 1) {
        var live = curve(rowAnchor(links.length), tip, true);
        html += stringLayer(live.d);
        place(plug, tip, live.angle);
      }
      cables.innerHTML = html;
      markNear();
    }

    function place(el, point, angle) {
      if (!el) return;
      el.style.left = point.x + 'px';
      el.style.top = point.y + 'px';
      el.style.setProperty('--ang', angle + 'deg');
    }

    function markNear() {
      board.querySelectorAll('[data-port]').forEach(function (port) {
        var id = port.getAttribute('data-port');
        var openPort = links.indexOf(id) === -1;
        var near = false;
        if (openPort && armed && !dragging) near = true;
        else if (openPort && dragging) {
          var p = slotPoint(id);
          near = Math.hypot(tip.x - p.x, tip.y - p.y) < 120;
        }
        port.classList.toggle('is-near', near);
      });
    }

    function localPoint(event) {
      var rect = board.getBoundingClientRect();
      return {
        x: Math.max(20, Math.min(rect.width - 20, event.clientX - rect.left)),
        y: Math.max(20, Math.min(rect.height - 20, event.clientY - rect.top))
      };
    }

    function nearestPort(clientX, clientY) {
      var best = null;
      var bestD = 88;
      board.querySelectorAll('[data-port]').forEach(function (port) {
        var rect = port.getBoundingClientRect();
        var d = Math.hypot(clientX - (rect.left + rect.width / 2), clientY - (rect.top + rect.height / 2));
        var inside = clientX >= rect.left - 18 && clientX <= rect.right + 18 && clientY >= rect.top - 18 && clientY <= rect.bottom + 18;
        if (inside) d = Math.min(d, 1);
        if (d < bestD) { bestD = d; best = port; }
      });
      return best;
    }

    function animateTo(dest, done) {
      var from = { x: tip.x, y: tip.y };
      var steps = reduce ? 1 : 16;
      var step = 0;
      function frame() {
        if (modal.hidden) return;
        step += 1;
        var t = Math.min(1, step / steps);
        var e = 1 - Math.pow(1 - t, 3);
        tip = { x: from.x + (dest.x - from.x) * e, y: from.y + (dest.y - from.y) * e };
        draw();
        if (t < 1) window.setTimeout(frame, 28);
        else done();
      }
      frame();
    }

    function signal(id) {
      if (reduce || !svg) return;
      var from = wireMode ? rowAnchor(Math.max(0, links.indexOf(String(id)))) : anchorPoint();
      var line = curve(from, slotPoint(id), false);
      var dot = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      dot.setAttribute('r', '3.5');
      dot.setAttribute('fill', '#fff4cc');
      var motion = document.createElementNS('http://www.w3.org/2000/svg', 'animateMotion');
      motion.setAttribute('dur', '0.7s');
      motion.setAttribute('repeatCount', '1');
      motion.setAttribute('path', line.d);
      dot.appendChild(motion);
      svg.appendChild(dot);
      window.setTimeout(function () { if (dot.parentNode) dot.remove(); }, 800);
    }

    function tone(freq, dur) {
      if (!soundOn) return;
      try {
        if (!audio) audio = new window.AudioContext();
        if (audio.state === 'suspended') audio.resume();
        var osc = audio.createOscillator();
        var gain = audio.createGain();
        osc.frequency.value = freq;
        gain.gain.setValueAtTime(0.03, audio.currentTime);
        gain.gain.exponentialRampToValueAtTime(0.001, audio.currentTime + dur);
        osc.connect(gain);
        gain.connect(audio.destination);
        osc.start();
        osc.stop(audio.currentTime + dur);
      } catch (error) {
        soundOn = false;
      }
    }

    function attempt(port) {
      if (busy || !port || modal.hidden || !playing) return;
      var id = port.getAttribute('data-port');
      ignorePortClick = true;
      window.setTimeout(function () { ignorePortClick = false; }, 480);
      armed = false;
      if (plug) {
        plug.classList.remove('is-armed');
        plug.setAttribute('aria-pressed', 'false');
      }
      if (links.indexOf(id) !== -1) {
        busy = true;
        animateTo(homePoint(), function () { busy = false; });
        return;
      }
      busy = true;
      animateTo(slotPoint(id), function () {
        if (modal.hidden) return;
        links.push(id);
        port.classList.add('is-live');
        var done = wireMode ? links.length >= 1 : links.length >= 4;
        if (done && plug) plug.hidden = true;
        draw();
        signal(id);
        tone(520, 0.08);
        if (!wireMode) say(LINES[id]);
        paintDots();
        if (wireMode && done) {
          port.classList.add('is-winding');
          if (board) board.classList.add('is-winding');
          later(wireDone, 1300);
        }
        else if (!wireMode && done) later(finale, 700);
        else {
          tip = homePoint();
          busy = false;
          draw();
        }
      });
    }

    function finale() {
      if (modal.hidden || !board) return;
      board.classList.add('is-alive');
      var step = 0;
      function next() {
        if (modal.hidden) return;
        var id = ORDER[step];
        var world = board.querySelector('[data-id="' + id + '"]');
        if (world) world.classList.add('is-live');
        signal(id);
        tone(420 + step * 70, 0.08);
        step += 1;
        if (step < ORDER.length) later(next, 520);
        else later(ending, 800);
      }
      next();
    }

    function ending() {
      if (modal.hidden || !board) return;
      section.setAttribute('data-phase', 'win');
      say('');
      var veil = document.createElement('div');
      veil.className = 'dcg-end';
      var title = document.createElement('h2');
      title.textContent = '🎉 VOCÊ CONECTOU A DIVERSÃO!';
      var line = document.createElement('p');
      line.textContent = 'Neste Dia das Crianças, que nunca faltem motivos para brincar, descobrir, criar e se conectar.';
      var wish = document.createElement('p');
      wish.className = 'dcg-kicker';
      wish.textContent = 'Feliz Dia das Crianças!';
      var actions = document.createElement('div');
      actions.className = 'dcg-end__actions';
      var link = document.createElement('a');
      link.className = 'dcg-btn';
      link.href = section.getAttribute('data-link') || '/collections/patch-cord';
      link.textContent = 'CONHECER NOSSOS CABOS';
      var again = document.createElement('button');
      again.type = 'button';
      again.className = 'dcg-textbtn';
      again.setAttribute('data-dcg-again', '');
      again.textContent = 'De novo';
      actions.appendChild(link);
      actions.appendChild(again);
      veil.appendChild(title);
      veil.appendChild(line);
      veil.appendChild(wish);
      veil.appendChild(actions);
      board.appendChild(veil);
      link.focus();
    }

    function follow() {
      if (!dragging) return;
      tip.x += (goal.x - tip.x) * (reduce ? 1 : 0.45);
      tip.y += (goal.y - tip.y) * (reduce ? 1 : 0.45);
      draw();
      window.requestAnimationFrame(follow);
    }

    function onDown(event) {
      var handle = event.target.closest && event.target.closest('[data-dcg-plug]');
      if (!handle || busy || modal.hidden || !playing || event.button > 0) return;
      dragging = true;
      moved = false;
      handle.classList.add('is-dragging');
      origin = { x: event.clientX, y: event.clientY };
      goal = localPoint(event);
      try { handle.setPointerCapture(event.pointerId); } catch (error) {}
      window.requestAnimationFrame(follow);
    }

    function onMove(event) {
      if (!dragging || !board) return;
      if (origin && Math.abs(event.clientX - origin.x) + Math.abs(event.clientY - origin.y) > 6) moved = true;
      goal = localPoint(event);
      tip.x += (goal.x - tip.x) * (reduce ? 1 : 0.7);
      tip.y += (goal.y - tip.y) * (reduce ? 1 : 0.7);
      draw();
    }

    function onUp(event) {
      if (!dragging) return;
      dragging = false;
      if (plug) plug.classList.remove('is-dragging');
      if (!moved) return;
      armed = false;
      if (plug) plug.classList.remove('is-armed');
      suppressClick = true;
      window.setTimeout(function () { suppressClick = false; }, 80);
      goal = localPoint(event);
      tip = { x: goal.x, y: goal.y };
      var hit = nearestPort(event.clientX, event.clientY);
      if (hit) attempt(hit);
      else {
        busy = true;
        animateTo(homePoint(), function () { busy = false; });
      }
    }

    section.addEventListener('pointerdown', onDown);
    window.addEventListener('pointermove', onMove);
    window.addEventListener('pointerup', onUp);
    window.addEventListener('pointercancel', function () {
      if (!dragging) return;
      dragging = false;
      tip = homePoint();
      draw();
    });

    section.addEventListener('click', function (event) {
      if (event.target.closest('[data-dcg-wire]')) {
        open();
        startWire();
      }
      if (event.target.closest('[data-dcg-close]')) close();
      if (event.target.closest('[data-dcg-start]')) begin();
      if (event.target.closest('[data-dcg-again]')) begin();
      if (event.target.closest('[data-dcg-secret]')) startWire();
      var copy = event.target.closest('[data-dcg-copy]');
      if (copy) {
        var code = 'CRIANCAS';
        var finishCopy = function () {
          copy.textContent = 'COPIADO';
          var note = app.querySelector('[data-dcg-copied]');
          var badge = app.querySelector('.dcg-code');
          if (note) {
            note.textContent = 'Copiado!';
            note.classList.remove('is-on');
            void note.offsetWidth;
            note.classList.add('is-on');
          }
          if (badge) {
            badge.classList.remove('is-copied');
            void badge.offsetWidth;
            badge.classList.add('is-copied');
          }
        };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(finishCopy).catch(finishCopy);
        else finishCopy();
      }
      var choice = event.target.closest('[data-dcg-choice]');
      if (choice) pick(choice);
      var handle = event.target.closest('[data-dcg-plug]');
      if (handle) {
        if (suppressClick) { suppressClick = false; return; }
        if (busy) return;
        armed = !armed;
        handle.classList.toggle('is-armed', armed);
        handle.setAttribute('aria-pressed', armed ? 'true' : 'false');
        markNear();
        return;
      }
      var port = event.target.closest('[data-port]');
      if (port && armed && !ignorePortClick) attempt(port);
    });

    if (soundBtn) {
      soundBtn.addEventListener('click', function () {
        soundOn = !soundOn;
        soundBtn.classList.toggle('is-on', soundOn);
        soundBtn.setAttribute('aria-pressed', soundOn ? 'true' : 'false');
        if (soundOn) tone(620, 0.06);
      });
    }
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (openBtn) {
      openBtn.addEventListener('click', function (event) {
        event.preventDefault();
        open();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (modal.hidden) return;
      if (event.key === 'Escape') { event.preventDefault(); close(); return; }
      if (event.key !== 'Tab' || !dialog) return;
      var items = dialog.querySelectorAll('button:not([disabled]), a[href]');
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });

    window.addEventListener('resize', function () {
      if (modal.hidden || !wireMode || dragging || busy || !board) return;
      draw();
    });
  }

  function stringLayer(d) {
    return '<path class="dcg-string is-glow" d="' + d + '"></path><path class="dcg-string" d="' + d + '"></path>';
  }

  function kiteOnly() {
    return '<svg viewBox="0 0 80 92" aria-hidden="true">' +
      '<polygon points="40,4 40,44 10,44" fill="#ff9000"/>' +
      '<polygon points="40,4 70,44 40,44" fill="#ffb800"/>' +
      '<polygon points="40,44 70,44 40,86" fill="#ffffff"/>' +
      '<polygon points="40,44 40,86 10,44" fill="#24306b"/>' +
      '<path d="M40 4 L40 86 M10 44 L70 44" fill="none" stroke="#ffffff" stroke-width="1.6"/>' +
    '</svg>';
  }

  function spoolSvg() {
    return '<svg viewBox="0 0 180 120" aria-hidden="true">' +
      '<defs><clipPath id="dcg-reel-clip"><rect x="52" y="34" width="76" height="44"/></clipPath></defs>' +
      '<ellipse cx="90" cy="104" rx="58" ry="6" fill="rgba(0,0,0,.4)"/>' +
      '<ellipse cx="40" cy="56" rx="15" ry="40" fill="#1b2438" stroke="rgba(255,255,255,.7)" stroke-width="2"/>' +
      '<ellipse class="dcg-reel__hub" cx="40" cy="56" rx="5" ry="14" fill="#ff9000"/>' +
      '<g class="dcg-reel__barrel">' +
        '<rect x="40" y="38" width="100" height="36" rx="5" fill="#ffb800"/>' +
        '<g clip-path="url(#dcg-reel-clip)">' +
          '<g class="dcg-reel__thread">' +
            '<rect x="20" y="44" width="140" height="4" fill="#fff4cc" opacity=".85"/>' +
            '<rect x="20" y="56" width="140" height="5" fill="#e07a00"/>' +
            '<rect x="20" y="68" width="140" height="3" fill="#fff4cc" opacity=".55"/>' +
            '<rect x="160" y="44" width="140" height="4" fill="#fff4cc" opacity=".85"/>' +
            '<rect x="160" y="56" width="140" height="5" fill="#e07a00"/>' +
            '<rect x="160" y="68" width="140" height="3" fill="#fff4cc" opacity=".55"/>' +
          '</g>' +
        '</g>' +
      '</g>' +
      '<ellipse cx="140" cy="56" rx="15" ry="40" fill="#12182c" stroke="rgba(255,255,255,.92)" stroke-width="2"/>' +
      '<ellipse class="dcg-reel__hub" cx="140" cy="56" rx="5" ry="13" fill="#fff6d8"/>' +
    '</svg>';
  }

  function parkScene(showKite) {
    return '<div class="dcg-park" aria-hidden="true">' +
      '<span class="dcg-balloon dcg-balloon--a"></span>' +
      '<span class="dcg-balloon dcg-balloon--b"></span>' +
      '<span class="dcg-balloon dcg-balloon--c"></span>' +
      (showKite === false ? '' :
      '<svg class="dcg-fly" viewBox="0 0 220 280">' +
        '<g class="dcg-kite-body">' +
          '<polygon points="112,8 112,58 74,58" fill="#ff9000"/>' +
          '<polygon points="112,8 150,58 112,58" fill="#ffb800"/>' +
          '<polygon points="112,58 150,58 112,112" fill="#ffffff"/>' +
          '<polygon points="112,58 112,112 74,58" fill="#24306b"/>' +
          '<path d="M112 8 L112 112 M74 58 L150 58" fill="none" stroke="#ffffff" stroke-width="1.8"/>' +
          '<path d="M112 112 C 86 158 146 196 102 262" fill="none" stroke="rgba(255,246,216,.9)" stroke-width="1.6" stroke-linecap="round"/>' +
        '</g>' +
      '</svg>') +
    '</div>';
  }

  function skyBits() {
    return '<span class="dcg-balloon dcg-balloon--a" aria-hidden="true"></span>' +
      '<span class="dcg-balloon dcg-balloon--b" aria-hidden="true"></span>' +
      '<span class="dcg-balloon dcg-balloon--c" aria-hidden="true"></span>' +
      '<i class="dcg-star" style="top:12%;left:18%"></i>' +
      '<i class="dcg-star" style="top:22%;left:72%;animation-delay:-1s"></i>' +
      '<i class="dcg-star" style="top:68%;left:12%;animation-delay:-2s"></i>' +
      '<i class="dcg-star" style="top:74%;left:84%;animation-delay:-.4s"></i>';
  }

  function scenery() {
    return '<svg class="dcg-scene" viewBox="0 0 1200 720" preserveAspectRatio="xMidYMid slice" aria-hidden="true">' +
      '<ellipse cx="220" cy="190" rx="170" ry="46" fill="rgba(255,184,0,.07)"/>' +
      '<ellipse cx="980" cy="170" rx="160" ry="42" fill="rgba(255,144,0,.07)"/>' +
      '<ellipse cx="250" cy="520" rx="180" ry="48" fill="rgba(255,255,255,.04)"/>' +
      '<ellipse cx="960" cy="510" rx="170" ry="46" fill="rgba(255,184,0,.06)"/>' +
      '<path d="M0 470 C160 420 280 530 470 470 C680 400 860 540 1200 430 L1200 720 L0 720 Z" fill="#1a2748"/>' +
      '<path d="M0 470 C160 420 280 530 470 470 C680 400 860 540 1200 430" fill="none" stroke="rgba(255,184,0,.35)" stroke-width="2"/>' +
      '<path d="M0 560 C220 500 420 620 700 540 C940 470 1080 590 1200 530 L1200 720 L0 720 Z" fill="#121a38"/>' +
      '<g fill="none" stroke="rgba(255,184,0,.28)" stroke-width="2">' +
        '<path d="M180 150 l10 18 20-6 -16 14 6 18 -20-12 -20 12 6-18 -16-14 20 6 z"/>' +
        '<circle cx="1040" cy="120" r="7"/>' +
        '<path d="M90 340 l8 8 h-16 z"/>' +
        '<rect x="1088" y="300" width="14" height="14" rx="2" transform="rotate(18 1095 307)"/>' +
      '</g>' +
      '<g fill="#fff6d8">' +
        '<circle cx="140" cy="90" r="2"/><circle cx="620" cy="70" r="1.6"/><circle cx="860" cy="110" r="2.2"/>' +
        '<circle cx="400" cy="250" r="1.4"/><circle cx="760" cy="220" r="1.5"/><circle cx="1120" cy="240" r="1.7"/>' +
      '</g>' +
    '</svg>';
  }

  function plugSvg() {
    return '<svg width="128" height="46" viewBox="0 0 128 46" aria-hidden="true">' +
      '<path d="M2 20 h44 v8 H2 z" fill="#c49214"/>' +
      '<path d="M2 18 h44 v6 H2 z" fill="#f0c014"/>' +
      '<path d="M6 21 h36" stroke="rgba(255,255,255,.75)" stroke-width="1.4"/>' +
      '<path d="M42 8 h48 l18 8 v14 l-18 8 H42 z" fill="#e8eef5"/>' +
      '<path d="M42 8 h48 l6 3 v-2 H48 z" fill="#f8fafc"/>' +
      '<rect x="54" y="3" width="22" height="6" rx="1.5" fill="#c9d2dc"/>' +
      '<rect x="98" y="15" width="16" height="16" rx="1" fill="#141a2c"/>' +
      '<g fill="#d7b15a"><rect x="84" y="17" width="1.5" height="12"/><rect x="87.2" y="17" width="1.5" height="12"/><rect x="90.4" y="17" width="1.5" height="12"/><rect x="93.6" y="17" width="1.5" height="12"/><rect x="96.8" y="17" width="1.5" height="12"/></g>' +
      '</svg>';
  }

  function scene(id) {
    if (id === 'jogar') {
      return '<svg viewBox="0 0 200 168" aria-hidden="true">' +
        '<ellipse cx="100" cy="150" rx="72" ry="10" fill="rgba(0,0,0,.28)"/>' +
        '<rect x="22" y="22" width="156" height="92" rx="12" fill="#31406e"/>' +
        '<rect x="30" y="30" width="140" height="70" rx="6" fill="#10162c"/>' +
        '<rect class="dcg-screen" x="36" y="36" width="128" height="58" rx="4"/>' +
        '<g class="dcg-pixel" fill="#fff6d0">' +
          '<rect x="48" y="48" width="8" height="8"/><rect x="58" y="48" width="8" height="8"/>' +
          '<rect x="68" y="58" width="8" height="8"/><rect x="78" y="48" width="8" height="8"/>' +
          '<rect x="108" y="44" width="6" height="6"/><rect x="124" y="62" width="7" height="7"/>' +
        '</g>' +
        '<rect x="86" y="112" width="28" height="10" fill="#151c34"/>' +
        '<rect x="46" y="122" width="108" height="22" rx="11" fill="#243156"/>' +
        '<rect x="58" y="128" width="10" height="10" fill="#0a0d2b"/>' +
        '<rect x="62" y="132" width="10" height="2" fill="#0a0d2b"/>' +
        '<circle cx="118" cy="133" r="3.2" fill="#ff9000"/>' +
        '<circle cx="130" cy="133" r="3.2" fill="#ffb800"/>' +
        '<g class="dcg-extra" fill="#ffb800"><circle cx="16" cy="28" r="2"/><circle cx="184" cy="40" r="1.6"/><circle cx="170" cy="18" r="1.4"/></g>' +
        '</svg>';
    }
    if (id === 'aprender') {
      return '<svg viewBox="0 0 200 168" aria-hidden="true">' +
        '<ellipse cx="100" cy="150" rx="70" ry="10" fill="rgba(0,0,0,.24)"/>' +
        '<path d="M46 128 l108 4 -6-14 H52 z" fill="#c4552a"/>' +
        '<path d="M38 116 V52 h58 v64 z" fill="#f3ecdf"/>' +
        '<g class="dcg-page"><path d="M104 116 V52 h58 v64 z" fill="#fff8ec"/>' +
          '<path d="M116 68 h34 M116 78 h28 M116 88 h30" stroke="#e4d3b0" stroke-width="2"/></g>' +
        '<path d="M50 68 h34 M50 78 h26 M50 88 h30" stroke="#d7c7a4" stroke-width="2"/>' +
        '<path d="M96 52 v64" stroke="#e7d7b4" stroke-width="2"/>' +
        '<rect x="132" y="34" width="8" height="52" rx="2" fill="#ff9000" transform="rotate(16 136 60)"/>' +
        '<rect x="134" y="34" width="8" height="8" rx="1" fill="#f4efe4" transform="rotate(16 136 60)"/>' +
        '<g class="dcg-extra" fill="#ffb800"><circle cx="34" cy="40" r="2.2"/><circle cx="168" cy="28" r="2.6"/><circle cx="176" cy="52" r="1.5"/><path d="M22 70 l4 7 7-3 -6 5 2 7 -7-4 -7 4 2-7 -6-5 7 3 z"/></g>' +
        '</svg>';
    }
    if (id === 'criar') {
      return '<svg viewBox="0 0 200 168" aria-hidden="true">' +
        '<ellipse cx="100" cy="152" rx="74" ry="10" fill="rgba(0,0,0,.24)"/>' +
        '<rect x="34" y="36" width="112" height="96" rx="8" fill="#f7f1e6" transform="rotate(-6 90 84)"/>' +
        '<circle cx="72" cy="72" r="14" fill="#ff9000"/>' +
        '<path d="M108 58 l18 32 h-36 z" fill="#ffb800"/>' +
        '<path d="M58 108 c18-14 32-8 52 4" fill="none" stroke="#0a0d2b" stroke-width="2.2" stroke-linecap="round"/>' +
        '<g class="dcg-ink">' +
          '<circle cx="148" cy="108" r="8" fill="#ff7a3c"/>' +
          '<circle cx="42" cy="48" r="5" fill="#7aa2ff"/>' +
          '<circle cx="160" cy="46" r="4" fill="#ffb800"/>' +
        '</g>' +
        '<rect x="150" y="78" width="7" height="42" rx="2" fill="#ff9000" transform="rotate(28 153 99)"/>' +
        '<rect x="156" y="92" width="7" height="36" rx="2" fill="#24345c" transform="rotate(18 159 110)"/>' +
        '<rect x="164" y="86" width="7" height="40" rx="2" fill="#ffb800" transform="rotate(38 167 106)"/>' +
        '</svg>';
    }
    return '<svg viewBox="0 0 200 168" aria-hidden="true">' +
      '<ellipse cx="100" cy="150" rx="68" ry="10" fill="rgba(0,0,0,.24)"/>' +
      '<circle cx="78" cy="96" r="34" fill="#24345c"/>' +
      '<circle cx="66" cy="86" r="10" fill="#1b2748"/>' +
      '<ellipse cx="78" cy="96" rx="50" ry="12" fill="none" stroke="rgba(255,184,0,.75)" stroke-width="2.4"/>' +
      '<g class="dcg-rocket">' +
        '<path class="dcg-flame" d="M128 96 l-14 6 14 6 z" fill="#ffb800"/>' +
        '<path d="M126 78 c18 8 28 16 28 24 s-10 16-28 24 l-8-24 z" fill="#f4f7fb"/>' +
        '<path d="M124 90 l-10 12 10 12 4-12 z" fill="#ff9000"/>' +
        '<circle cx="142" cy="102" r="4" fill="#ffb800"/>' +
      '</g>' +
      '<g class="dcg-extra" fill="#fff6d0">' +
        '<circle cx="28" cy="36" r="2.2"/><circle cx="150" cy="28" r="1.8"/>' +
        '<circle cx="176" cy="58" r="1.5"/><circle cx="40" cy="70" r="1.4"/>' +
        '<path d="M168 40 l3 6 6-2 -4 4 2 6 -7-3 -6 4 1-6 -5-4 6 2 z"/>' +
      '</g>' +
      '</svg>';
  }

  function start() {
    document.querySelectorAll('[data-dcg]').forEach(boot);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  document.addEventListener('shopify:section:load', function (event) {
    var node = event.target && event.target.querySelector('[data-dcg]');
    if (node) boot(node);
  });
})();
